/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AwardTypeBaseModelIEnumerableResponseWrapper } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class AwardTypes<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags PageantAvailableTitle
   * @name GetAllAwardTypes
   * @request GET:/AwardTypes
   */
  getAllAwardTypes = (params: RequestParams = {}) =>
    this.request<AwardTypeBaseModelIEnumerableResponseWrapper, any>({
      path: `/AwardTypes`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
